<template>
  <b-table
    :items="items"
    :fields="fields"
    selectable
    striped
    small
    primary-key="name"
    :tbody-transition-props="transProps"
    sort-by.sync="ApprovedFinancingAmount"
    sort-desc.sync
  >
    <template #head(amount)="">
      <span>{{ selectedButton }}</span>
    </template>
    <template #head(operationModality)="">
      Modality
    </template>
    <template #cell(name)="data">
      <i
        class="far fa-comments text-warning mr-2"
        v-b-tooltip.hover.top
         :title="data.item.steps.note"
      ></i>

      <span>
        {{ data.item.name }}
      </span>
    </template>

    <template #cell(amount)="data">
      <span v-if="selectedButton === 'Estoque'">
        {{ data.item.approvedFinancingAmount | currency }}
      </span>
      <span v-if="selectedButton === 'Fluxo'">
        {{ data.item.intendedFinancingValue | currency }}
      </span>
      <span v-if="selectedButton === 'Resultado'">
        {{ data.item.operationValue | currency }}
      </span>
    </template>
  </b-table>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "branchProposalsTable",
  props: {
    proposals: {
      type: Array,
      default: () => [],
    },
    selectedButton: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "cpf", sortable: true },
        { key: "operationModality", sortable: true },
        { key: "amount", sortable: true },
      ],
      transProps: {
        name: "flip-list",
      },
    };
  },
  computed: {
    items() {
      return this.proposals;
    },
  },
  methods: {
    ...mapActions([]),
  },
};
</script>
